import React, { useState, useEffect } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  ManagePromocode,
  showMessage,
  getToken,
  trimFirstAndLastWhiteSpace,
} from "../../Functionalities/Functions";
import FilterComponent from "../../CoreComponents/FilterComponent";
import axios from "axios";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import { is_superuser, is_franchise_admin, is_franchise_manager, is_franchise_staff, protocol } from "../../Functionalities/Config";
import LoadingComponent from "../../CoreComponents/LoadingComponent";

function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true)
  const [filter, setfilter] = useState({
    search_text: "",
    is_active: "",
    is_expired: "",
    to_be_active: "",
    maxed_out: "",
  });

  useEffect(() => {
    getData();
  }, []);


  let params =
    "&search_text=" +
    trimFirstAndLastWhiteSpace(filter.search_text)+
    "&is_active=" +
    filter.is_active +
    "&is_expired=" +
    filter.is_expired +
    "&to_be_active=" +
    filter.to_be_active +
    "&maxed_out=" +
    filter.maxed_out;

  const getData = () => {
    // showMessage("Loading promocode", "info", "Loading", "bottom", "bottom-left", 0); //shabeeb change

    // let result = ManagePromocode("", "", "get", "");
    let result = ManagePromocode("", "", "get", params); //ashif changed

    result.then((result) => {
      setData({
        ...data,
        data: result.data.results,
      });
      setLoading(false)
      setNext(result.data.next);
      setPrev(result.data.previous);
    })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };



  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  return (
    <div class="content-body">

      {
        !loading ?
          <div class="container-fluid">
            <FilterComponent
              handleNext={handleNext}
              handlePrev={handlePrev}
              next={next}
              prev={prev}
              addItemName={(is_superuser  || is_franchise_admin || is_franchise_manager || is_franchise_staff)  && "Add Promocode"}
              addItemPath={(is_superuser  || is_franchise_admin || is_franchise_manager || is_franchise_staff) && "/addpromo"}
              filterButtonName={"Filter"}
            />

            <div className="row">
              <div className="col-xl-12 ">
                <div className="card">
                  <div className="card-header border-0 pb-0 d-sm-flex d-block">
                    <div className="d-sm-flex mb-lg-4 mb-2"></div>
                  </div>

                  <FilterModalComponent heading={"Filter Promocode"} searchItemValue={filter.search_text} searchItemChange={(e) =>
                    setfilter({
                      ...filter,
                      search_text: e.target.value,
                    })
                  }

                    clearFilter={(e) => {
                      e.preventDefault();
                      window.location.reload();
                    }}

                    submitFilter={(e) => {
                      e.preventDefault();
                      getData();
                    }} >

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="text-black font-w600">
                          Active <span className="required"></span>
                        </label>
                        <select
                          value={filter.is_active}
                          class="form-control form-control-lg  "
                          onChange={(e) =>
                            setfilter({
                              ...filter,
                              is_active: e.target.value,
                            })
                          }
                        >
                          <option value={""} id={""}>
                            All
                      </option>
                          <option value={"1"} id={"1"}>
                            Yes
                      </option>
                          <option value={"0"} id={"0"}>
                            No
                      </option>
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="text-black font-w600">
                          Expired <span className="required"></span>
                        </label>
                        <select
                          value={filter.is_expired}
                          class="form-control form-control-lg  "
                          onChange={(e) =>
                            setfilter({
                              ...filter,
                              is_expired: e.target.value,
                            })
                          }
                        >
                          <option value={""} id={""}>
                            All
                      </option>
                          <option value={"true"} id={"true"}>
                            Yes
                      </option>
                          <option value={"false"} id={"false"}>
                            No
                      </option>
                        </select>
                      </div>
                    </div>




                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="text-black font-w600"> MaxedOut <span className="required"></span>
                        </label>
                        <select value={filter.maxed_out} class="form-control form-control-lg  " onChange={(e) =>
                          setfilter({
                            ...filter,
                            maxed_out: e.target.value,
                          })
                        } >
                          <option value={""} id={""}> All </option>
                          <option value={"true"} id={"true"}> Yes </option>
                          <option value={"false"} id={"false"}> No </option>
                        </select>
                      </div>
                    </div>


                  </FilterModalComponent>

                  <div className="card-body " className="table-responsive">
                    <table className="table table-responsive-md">
                      <thead>
                        <tr>
                          <th>PROMO ID</th>
                          <th>PROMO CODE</th>
                          <th>DETAILS</th>
                          <th>FROM DATE</th>
                          <th>EXPIRY DATE</th>
                          <th>ALLOWED USER</th>
                        </tr>
                      </thead>
                      <tbody>
                        {" "}
                        {data.data.length > 0 &&
                          data.data.map((promo, index) => {
                            var running = true
                            var d1 = new Date();
                            var d2 = new Date(promo.expiry_date);
                            // void 0
                            if (d1.getTime() === d2.getTime()) {
                              // void 0
                            }
                            else if (d1.getTime() < d2.getTime()) {
                              // void 0
                              // setrunning(true)
                              running = true

                            }

                            else if (d1.getTime() > d2.getTime()) {
                              // void 0
                              // setrunning(false)
                              running = false

                            }

                            return (
                              <>
                                <tr>
                                  <td>
                                    <a href={(is_superuser  || is_franchise_admin || is_franchise_manager || is_franchise_staff) && `/editpromo/${promo.id}`}>
                                      <h5 className="mb-0 fs--1">
                                        FDRPRCD{promo.id}
                                      </h5>
                                      <div className="mt-2" style={{ marginTop: "10px", border: '1px solid red', borderRadius: '5px', padding: '3px', borderColor: "#51B04A", fontWeight: "bold", display: "flex", justifyContent: "center", color: "white", backgroundColor: running ? "#51B04A" : "red", fontSize: 12 }}>
                                        {running ? "Running" : "Expired"}
                                      </div>
                                    </a>
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <a href={(is_superuser  || is_franchise_admin || is_franchise_manager || is_franchise_staff) && `/editpromo/${promo.id}`}>
                                        <span className="w-space-no">
                                          {promo.is_active === false ? (
                                            <>
                                              <i className="fa fa-circle text-danger mr-1 " />{" "}
                                            </>
                                          ) : (
                                            <>
                                              <i className="fa fa-circle text-success mr-1 " />{" "}
                                            </>
                                          )}{' '}
                                          {promo.code}
                                          {promo.is_for_new_user && (
                                            <span className="badge badge-sm badge-info ml-2" style={{ fontSize: "10px" }}>New User</span>
                                          )}
                                          
                                          {promo.restaurent_name&&<>
                                          <br/><i class="fa fa-cutlery mr-2" title={promo.restaurent_name}></i>{promo.restaurent_name?promo.restaurent_name:''}
                                          </>}
                                          
                                        </span>
                                      </a>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <a href={(is_superuser  || is_franchise_admin || is_franchise_manager || is_franchise_staff) && `/editpromo/${promo.id}`}>
                                      {promo.description  && <><b title={promo.description}>{promo.description.length>50?promo.description.slice(0,35)+"...":promo.description}​​​​​​​​</b></>}
                                      <br/>
                                        {promo.disc_perc > 0 && <><b>{promo.disc_perc}​​​​​​​​</b>% Discount </>}
                                        {promo.disc_perc > 0 && promo.uplimit > 0 && <> upto ​​​​​​​<b>{promo.uplimit}​​​​​​​​</b> rs </>}
                                        {promo.flat_disc > 0 && <> Flat ​​​​​​​​<b>{promo.flat_disc}​​​​​​​​</b> rs off ​​​​​​​​</>}
                                        {promo.min_amount > 0 && <> for orders above ​​​​​​​​<b>{promo.min_amount}​​​​​​​​</b></>}
                                        <br />
                                     Recurrence : <b>{promo.recurrence}​​​​​​​​</b>
                                      </a>
                                    </div>
                                  </td>
                                  <td>
                                    {/* {void 0} */}
                                    <div className="d-flex align-items-center">
                                      <span className="w-space-no">
                                        {promo.from_date == null ? "No Date" :
                                          new Date(promo.from_date).toLocaleDateString()
                                        }
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <span className="w-space-no">
                                        {new Date(promo.expiry_date).toLocaleDateString()}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a href={(is_superuser || is_franchise_admin || is_franchise_manager || is_franchise_staff) && `/editpromo/${promo.id}`}>
                                      <div className="d-flex align-items-center">
                                        <span className="w-space-no">
                                          {/* {promo.allowed_users
                                        ? promo.allowed_users
                                        : "ALL"} */}
                                          {promo.alloed_users.length != 0? 
                                          <i class="fa fa-user"></i>: <i class="fa fa-users"></i>
                                          }
                                          {/* {promo.applicable_branches.length != 0? 
                                          <i class="fa fa-cutlery ml-2"></i>: <i class=""></i>
                                          } */}

                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                </tr>
                              </>
                            );
                          })}{" "}
                      </tbody>
                    </table>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
          : <LoadingComponent />
      }
    </div >
  );
}
function Promocode() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Promo code"} subHeading={"All promo code under foodoor"} />
        <NavBar />{" "}
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Promocode;
